import { useQueryFetch } from '@shared/hooks/useQueryFetch';
import type { ReceptionScheduleVm } from '@shared/types/process';

import { useMemo } from 'react';

export type ReceptionSchedulesResponse =
    | ReceptionScheduleVm[]
    | {
          itemList?: ReceptionScheduleVm[];
          data?: ReceptionScheduleVm[] | { itemList?: ReceptionScheduleVm[] };
      };

export const getReceptionSchedules = (
    response?: ReceptionSchedulesResponse,
): ReceptionScheduleVm[] => {
    if (!response) return [];
    if (Array.isArray(response)) return response;
    if (Array.isArray(response.data)) return response.data;

    return response.data?.itemList ?? response.itemList ?? [];
};

export function useReceptionSchedules(serviceId?: string, enabled = true) {
    const query = useQueryFetch<ReceptionSchedulesResponse>(
        'flow/Account/Services/GetReceptionSchedules',
        {
            params: { serviceId },
            enabled: enabled && !!serviceId,
        },
    );

    const schedules = useMemo(
        () => getReceptionSchedules(query.data),
        [query.data],
    );

    return { ...query, schedules };
}
